import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import StatsContainer from '../components/StatsContainer';
import { getUserStats } from '../features/user/userSlice';

const Stats = () => {
  const dispatch = useDispatch();
  const { account, chainId } = useSelector((store) => store.user);

  useEffect(() => {
    dispatch(getUserStats());
  }, [account, chainId, dispatch]);

  return <StatsContainer />;
};

export default Stats;
